/* eslint-disable max-lines-per-function */
import React from 'react';
export const FeaturesTwoColumnsPreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="252" viewBox="0 0 287 252">
        <g id="Features:_two_columns" data-name="Features: two columns" transform="translate(-817 -798)">
            <g id="background" transform="translate(817 798)" fill="#fff">
                <rect width="287" height="252" rx="4" stroke="none" />
                <rect x="0.5" y="0.5" width="286" height="251" rx="3.5" fill="none" />
            </g>
            <text
                id="copy2"
                transform="translate(1004 941)"
                fill="#718096"
                fontSize="12"
                fontFamily="Nunito-SemiBold, Nunito"
                fontWeight="600"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g id="Group_12456" data-name="Group 12456" transform="translate(973 822)">
                <g id="Group_8115" data-name="Group 8115">
                    <g id="Rectangle_6270" data-name="Rectangle 6270" fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1">
                        <rect width="107" height="95" rx="4" stroke="none" />
                        <rect x="0.5" y="0.5" width="106" height="94" rx="3.5" fill="none" />
                    </g>
                </g>
                <g id="campaign-placeholder" transform="translate(40.313 35.69)">
                    <g id="Rectangle_7981" data-name="Rectangle 7981" fill="none" stroke="#cbd5e1" strokeWidth="2">
                        <rect width="26" height="26" rx="5" stroke="none" />
                        <rect x="1" y="1" width="24" height="24" rx="4" fill="none" />
                    </g>
                    <path
                        id="Path_26926"
                        data-name="Path 26926"
                        d="M711.088,6953.823l4.677-5.247,5.572,4.429"
                        transform="translate(-710.021 -6935.788)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        id="Path_26927"
                        data-name="Path 26927"
                        d="M698.488,6964.856l14.983-16.28,5.847,5.479"
                        transform="translate(-693.859 -6940.051)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <g
                        id="Ellipse_1907"
                        data-name="Ellipse 1907"
                        transform="translate(5.196 4.732)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeWidth="2"
                    >
                        <ellipse cx="2.305" cy="2.305" rx="2.305" ry="2.305" stroke="none" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" fill="none" />
                    </g>
                </g>
            </g>
            <text
                id="copy2-2"
                data-name="copy2"
                transform="translate(842 953)"
                fill="#a0aec0"
                fontSize="10"
                fontFamily="Mulish-Regular, Mulish"
                letterSpacing="-0.03em"
            >
                <tspan x="0" y="10">
                    This is the place for your{' '}
                </tspan>
                <tspan x="0" y="22">
                    content. Did you know{' '}
                </tspan>
                <tspan x="0" y="34">
                    that email marketing...
                </tspan>
            </text>
            <text
                id="copy2-3"
                data-name="copy2"
                transform="translate(973 953)"
                fill="#a0aec0"
                fontSize="10"
                fontFamily="Mulish-Regular, Mulish"
                letterSpacing="-0.03em"
            >
                <tspan x="0" y="10">
                    This is the place for your{' '}
                </tspan>
                <tspan x="0" y="22">
                    content. Did you know{' '}
                </tspan>
                <tspan x="0" y="34">
                    that email marketing...
                </tspan>
            </text>
            <text
                id="copy2-4"
                data-name="copy2"
                transform="translate(872 941)"
                fill="#718096"
                fontSize="12"
                fontFamily="Nunito-SemiBold, Nunito"
                fontWeight="600"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g id="Group_12456-2" data-name="Group 12456" transform="translate(841 822)">
                <g id="Group_8115-2" data-name="Group 8115">
                    <g id="Rectangle_6270-2" data-name="Rectangle 6270" fill="#edf2f7" stroke="#e2e8f0" strokeWidth="1">
                        <rect width="107" height="95" rx="4" stroke="none" />
                        <rect x="0.5" y="0.5" width="106" height="94" rx="3.5" fill="none" />
                    </g>
                </g>
                <g id="campaign-placeholder-2" data-name="campaign-placeholder" transform="translate(40.315 35.69)">
                    <g id="Rectangle_7981-2" data-name="Rectangle 7981" fill="none" stroke="#cbd5e1" strokeWidth="2">
                        <rect width="26" height="26" rx="5" stroke="none" />
                        <rect x="1" y="1" width="24" height="24" rx="4" fill="none" />
                    </g>
                    <path
                        id="Path_26926-2"
                        data-name="Path 26926"
                        d="M711.088,6953.823l4.677-5.247,5.572,4.429"
                        transform="translate(-710.021 -6935.788)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        id="Path_26927-2"
                        data-name="Path 26927"
                        d="M698.488,6964.856l14.983-16.28,5.847,5.479"
                        transform="translate(-693.859 -6940.051)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <g
                        id="Ellipse_1907-2"
                        data-name="Ellipse 1907"
                        transform="translate(5.196 4.732)"
                        fill="none"
                        stroke="#cbd5e1"
                        strokeLinecap="round"
                        strokeWidth="2"
                    >
                        <ellipse cx="2.305" cy="2.305" rx="2.305" ry="2.305" stroke="none" />
                        <ellipse cx="2.305" cy="2.305" rx="1.305" ry="1.305" fill="none" />
                    </g>
                </g>
            </g>
            <g
                id="Button_-_Website_Primary_Button"
                data-name="Button - Website Primary Button"
                transform="translate(870 1000)"
            >
                <rect
                    id="Button_background"
                    data-name="Button background"
                    width="50"
                    height="26"
                    rx="4"
                    fill="#718096"
                />
                <text
                    id="Button"
                    transform="translate(10 17)"
                    fill="#fff"
                    fontSize="10"
                    fontFamily="Mulish-Regular, Mulish"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g
                id="Button_-_Website_Primary_Button-2"
                data-name="Button - Website Primary Button"
                transform="translate(1002 1000)"
            >
                <rect
                    id="Button_background-2"
                    data-name="Button background"
                    width="50"
                    height="26"
                    rx="4"
                    fill="#718096"
                />
                <text
                    id="Button-2"
                    data-name="Button"
                    transform="translate(10 17)"
                    fill="#fff"
                    fontSize="10"
                    fontFamily="Mulish-Regular, Mulish"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);
